<template>
  <div :class="['integration', {'is-included': isIncluded}]">
    <div
      v-if="isIncluded"
      class="integration--status"
    >
      <icon-default icon="check"/>
    </div>

    <div>
      <p v-if="type" class="integration--type">{{ type }}</p>

      <div class="integration--header">
        <img
          v-if="iconPath"
          class="integration--header--logo"
          :src="iconPath"
          :alt="heading"
        />
        <h2 class="integration--header--heading">{{ heading }}</h2>
      </div>

      <div class="integration--description">
        <slot></slot>
      </div>
    </div>

    <div class="integration--main">
      <div class="integration--main--actions">
        <button-outlined
          class="is-fullwidth"
          @click="$emit('changeStatus')"
          :disabled="isDisabled"
        >{{ isIncluded ? 'No, Don\'t Setup Integration' : 'Yes, Setup This Integration' }}
        </button-outlined>
      </div>

      <p v-if="isDisabled" class="mt-50 has-text-muted is-italic is-size-7">{{ disabledText }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "IntegrationBox",
  props: {
    heading: {
      type: String,
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
    iconPath: {
      type: String,
      required: true,
    },
    isIncluded: {
      type: Boolean,
      default: false,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    disabledText: String,
  },
}
</script>

<style lang="scss" scoped>
@import "../../../styles/variables/variables";

.integration {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 48%;
  position: relative;
  margin-bottom: 20px;
  padding: 12px;
  border: 2px solid $border;

  &.is-included {
    border-color: $secondary;
  }
}

.integration--status {
  position: absolute;
  top: 0;
  right: 0;
  height: 30px;
  width: 30px;
  padding-top: 4px;
  padding-left: 2px;
  background-color: $secondary;
  color: $white;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    right: 100%;
    width: 0;
    height: 0;
    border-left: 30px solid transparent;
    border-top: 30px solid $secondary;
  }

  &::after {
    content: '';
    position: absolute;
    top: 100%;
    left: 0;
    width: 0;
    height: 0;
    border-left: 30px solid transparent;
    border-top: 30px solid $secondary;
  }
}

.integration--type {
  margin-bottom: 6px;
  font-size: 0.875rem;
  color: $text-muted;
}

.integration--header {
  display: flex;
  align-items: center;

  &--logo {
    height: 18px;
    margin-right: 8px;
  }

  &--heading {
    font-size: 20px;
    font-weight: bold;
    color: $primary;
  }
}

.integration--description {
  margin: 0.5rem 0 1rem;
  line-height: 1.3;

  p {
    font-size: 0.875rem;
  }
}

.integration--main {

  &--column {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  &--actions {
    display: flex;
    justify-content: stretch;
    margin-top: 8px;
  }
}
</style>
